module.exports = __webpack_public_path__ + "static/media/algae8.ee7af114.svg";